'use strict';

angular.module('openDataApp')
  .controller('ResetFormCtrl', ['$scope', '$q', '$timeout', '$stateParams', '$location', 'ApiService', function ($scope, $q, $timeout, $stateParams, $location, ApiService) {

    if ($stateParams.token === undefined || $stateParams.token.length === 0) {
      $location.path('/');
    }

    $scope.submit = function (formData) {
      $scope.submitting = true;
      $scope.resetFormSubmitError = null;

      var def = $q.defer();

      ApiService.passwordReset(formData, $stateParams.token)
        .then(
          function success() {
            $scope.submitting = false;
            $scope.greatSuccess = true;
            def.resolve();
          },
          function error(response) {
            $scope.submitting = false;
            if (response.status === 401) {
              $scope.resetFormSubmitError = 'Deze link is niet (meer) geldig. Vraag een nieuwe link aan via <a href="/">het inlogscherm</a>.';
            } else {
              $scope.resetFormSubmitError = 'Er is iets misgegaan, dat ligt aan ons. We zijn ermee aan de slag, probeer het later nog eens.';
            }
            def.reject();
          }
        );

      return def.promise;
    };
  }]);
